var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step-layout"
  }, [_c('div', {
    staticClass: "step-content"
  }, [_vm.currentNode && !_vm.isLoading ? _c(_vm.currentNode.component, _vm._b({
    tag: "component",
    on: {
      "input": _vm.onValueChange
    }
  }, 'component', _vm.componentProps, false)) : _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()], 1), _vm.currentNode && !_vm.isLoading ? _c('div', {
    staticClass: "step-nav"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": _vm.canProceed,
      "backButtonIsVisible": _vm.backButtonIsVisible,
      "nextButtonIsVisible": _vm.nextButtonVisible,
      "textForNextStep": _vm.textForNextStep,
      "isCentered": _vm.currentNode.component === 'Success'
    },
    on: {
      "back": _vm.handleBack,
      "next": _vm.handleNext
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }